import React from "react";
import EngagementSessionListPage from "./EngagementSessionListPageSwitch";
import { fetchPopularList, replacePopularList } from "../../../actions/sessionListsActions";

const EngagementPopularListPage = () => (
  <EngagementSessionListPage
    title="Popular Sessions"
    description="Manage the ordered list of sessions shown as Popular in the apps. Drag to reorder, remove with the trash icon, then click Save changes to publish."
    sliceName="popular_list"
    fetchList={fetchPopularList}
    replaceList={replacePopularList}
  />
);

export default EngagementPopularListPage;
